import React from 'react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
const Title = ({ children }) => {
    const { text900Clsx } = useBackgroundContext();
    return React.createElement("h3", { className: clsx(text900Clsx) }, children);
};
const Description = ({ children }) => {
    const { text500Clsx } = useBackgroundContext();
    return (React.createElement("p", { className: clsx('mt-2 max-w-4xl overflow-hidden overflow-ellipsis', text500Clsx) }, children));
};
const Simple = ({ title, children }) => {
    return (React.createElement("div", { className: "pb-5" },
        React.createElement(Title, null, title),
        children && React.createElement("div", { className: "mt-3 sm:mt-4" }, children)));
};
const WithDescription = ({ title, description, children }) => {
    return (React.createElement("div", { className: "pb-5 " },
        React.createElement(Title, null, title),
        React.createElement(Description, null, description),
        children && React.createElement("div", { className: "mt-3 sm:mt-4" }, children)));
};
const WithAction = ({ title, action, children }) => {
    return (React.createElement("div", { className: "pb-5 " },
        React.createElement("div", { className: "sm:flex sm:justify-between sm:items-baseline" },
            React.createElement(Title, null, title),
            React.createElement("div", { className: "mt-3 flex sm:mt-0 sm:ml-4 space-x-3" }, action)),
        children && React.createElement("div", { className: "mt-3 sm:mt-4" }, children)));
};
const WithDescriptionAndAction = ({ title, description, action, children }) => {
    return (React.createElement("div", { className: "pb-5 " },
        React.createElement("div", { className: "sm:flex sm:justify-between sm:items-baseline" },
            React.createElement("div", { className: "sm:w-0 sm:flex-1" },
                React.createElement(Title, null, title),
                React.createElement(Description, null, description)),
            React.createElement("div", { className: "mt-3 flex sm:mt-0 sm:ml-4 space-x-3" }, action)),
        children && React.createElement("div", { className: "mt-3 sm:mt-4" }, children)));
};
export const SectionHeader = (props) => {
    const { title, description, action, children, className } = props;
    let content;
    if (!!title && !!description && !!action) {
        content = (React.createElement(WithDescriptionAndAction, { title: title, description: description, action: action }, children));
    }
    else if (action) {
        content = (React.createElement(WithAction, { title: title, action: action }, children));
    }
    else if (description) {
        content = (React.createElement(WithDescription, { title: title, description: description }, children));
    }
    else if (title) {
        content = React.createElement(Simple, { title: title }, children);
    }
    else {
        content = children;
    }
    return React.createElement("div", { className: className }, content);
};
//# sourceMappingURL=SectionHeader.js.map